import { render, staticRenderFns } from "./GatewayDocumentView.html?vue&type=template&id=6ea017e8&scoped=true&"
import script from "./GatewayDocumentView.js?vue&type=script&lang=js&"
export * from "./GatewayDocumentView.js?vue&type=script&lang=js&"
import style0 from "./GatewayDocumentView.scss?vue&type=style&index=0&id=6ea017e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea017e8",
  null
  
)

export default component.exports